import { render, staticRenderFns } from "./ProductTour.vue?vue&type=template&id=28203eb4"
import script from "./ProductTour.vue?vue&type=script&lang=js"
export * from "./ProductTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports